<mat-card class="example-card">
  <mat-card-header>
    <mat-card-title>{{card.imageName}}</mat-card-title>
  </mat-card-header>
  <img  mat-card-image [classList]=card.customStyle class="img-zoom-hover" [src]=card.image alt="" >
  <mat-card-content>
    <p style="white-space: break-spaces;">
    </p>
  </mat-card-content>
</mat-card>
